<template>
  <div id="treehistorys" class="tables">
    <!-- 树状图 -->
    <div class="history_meter" :style="height" style="min-height:250px">
      <div v-show="iSshow" class="history_meter_box">
        <div class="sapnbox" id="box">
          {{ textname }}
          <span v-show="iconone" class="el-icon-close"></span>
          <span v-show="iconss" class="el-icon-plus" @click="Newlybtn"></span>
          <span class="el-icon-d-arrow-left" @click="remain"></span>
        </div>
        <div class="history_lists" :style="heighttree" style="min-height:262px">
          <el-tree
            :data="datas"
            :datashuju="data"
            :props="defaultProps"
            accordion
            @node-click="handleNodeClick"
            :highlight-current="false"
            node-key="id"
            icon-class="iconfont icon-file-close"
            :default-expanded-keys="[0]"
          ></el-tree>
        </div>
      </div>
      <div v-show="!iSshow" class="sapnbox2" @click="remain">
        <span class="el-icon-d-arrow-right"></span>
        <!-- <div style="margin-top: 15px;">{{ textname }}</div> -->
      </div>
    </div>
    <div @mousedown.stop.prevent="mouseDown" v-if="iSshow" class="asdzczc" :style="style"></div>
    <div v-if="!iSshow" class="asdzczcs"></div>
    <housetable
      :totals="totals"
      :pageSizes="pageSizes"
      :currentPages="currentPages"
      :tableData="tableData"
      :isInner="isInner"
      :Header="Header"
      :IfShow="IfShow"
      :maxs="maxs"
      @rowdblclick="rowdblclick"
      @rowclick="rowclick"
      @clickIcon="clickIcon"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      class="righttagBox"
    />
  </div>
</template>
<script>
// import local from "@/utils/local.js";
// import session from "../../../utils/session";
// import housetable from "../housetable/housetable.vue";
export default {
  components: {
    // housetable
  },
  name: "treehistorys",
  data() {
    return {
      IfShows: this.IfShow,
      maxss: this.maxs,
      iSshow: true,
      data: this.datas,
      icon: this.iconone,
      icons: this.iconss,
      style: "cursor:e-resize",
      defaultProps: {
        children: "children",
        label: "label"
      },
      textname: this.text,
      total: this.totals,
      currentPage: this.currentPages,
      pageSize: this.pageSizes,
      ObtainHeader: this.Header,
      isInners: this.isInner,
      tableDatas: this.tableData,
      Hierarchy: this.HierarchyS,
      showsummary: this.ShowSummary
    };
  },
  props: {
    IfShow: {
      type: Boolean,
      default: false
    },
    ShowSummary: {
      type: Boolean,
      default: false
    },
    maxs: {
      type: String,
      default: "400"
    },
    height: {
      type: String,
      default: "height:400px"
    },
    heighttree: {
      type: String,
      default: "height:420px"
    },
    columnS: {
      type: Boolean,
      default: true
    },
    mrdk: Array,
    HierarchyS: Array,
    Header: Array,
    tableData: Array,
    currentPages: Number,
    pageSizes: Number,
    totals: Number,
    isInner: {
      type: Boolean,
      default: true
    },
    max: String,
    iconone: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "分类信息"
    },
    iconss: {
      type: Boolean,
      default: false
    },
    datas: Array,
    datashuju: {
      type: Array
    }
  },
  methods: {
    // 双击一行
    rowdblclick(obj) {
      this.$emit("rowdblclick", obj);
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },

    keydownss(data) {
      this.$emit("keydownss", data);
    },
    deleteClickS(data, index) {
      this.$emit("deleteClickS", data, index);
    },
    rowclick(data) {
      this.$emit("rowclick", data);
    },
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSizeChange(val) {
      //  console.log(val);
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      //  console.log(val);
      this.$emit("handleCurrentChange", val);
    },
    deleteClick(index) {
      this.$emit("deleteClick", index);
    },
    dblclick(data) {
      this.$emit("dblclick", data);
    },
    handleClick(obj) {
      this.$emit("handleClick", obj);
    },
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    },
    Relieveclick(data, index) {
      this.$emit("Relieveclick", data, index);
    },
    constraintclick(data, index) {
      this.$emit("constraintclick", data, index);
    },
    Newlybtn() {
      this.$emit("Newlybtn");
    },
    // shanchuclick() {
    //   this.$emit("shanchuclick");
    // },
    remain() {
      if (this.iSshow == true) {
        this.iSshow = false;
      } else {
        this.iSshow = true;
      }
    },
    remains() {
      this.iSshow = true;
    },
    handleNodeClick(data, node, text) {
      this.$emit("handleNodeClick", data);
    },
    // 拖拽改变宽度
    mouseDown(ev) {
      document.documentElement.addEventListener(
        "mousemove",
        this.mouse_move,
        true
      );
      const tagBox = document.getElementById("box");
      const iEvent = ev || event;
      this.dx = iEvent.clientX;
      this.dw = tagBox.offsetWidth;
      // if (iEvent.clientX > tagBox.offsetLeft + 10) {
      //     this.resizing = 'left';
      // }
    },
    mouse_move(ev) {
      const tagBox = document.getElementById("box");
      const iEvent = ev || event;
      // console.log(tagBox.style.width);
      if (tagBox.style.width >= 1000) {
        tagBox.style.width = "1000px";
      }
      tagBox.style.width = `${this.dw + (iEvent.clientX - this.dx)}px`;
    },
    mouseUp() {
      document.documentElement.removeEventListener(
        "mousemove",
        this.mouse_move,
        true
      );
    },
  
  },
  // 创建生命周期钩子函数
  mounted() {
    document.documentElement.addEventListener("mouseup", this.mouseUp, true);
  },
  created() {
  },
  watch: {
    iSshow: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.style = "cursor:e-resize";
        } else {
          this.style = "cursor:default";
        }
      }
    }
  }
};
</script>
<style lang="less">
.tables {
  width: 100%;
  height: 300px;
  display: -webkit-box !important;
  display: box !important;
  position: relative;

  .righttagBox {
    height: 100%;
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;

    .el-button--small {
      padding: 5px 1px;
    }

    .el-button {
      font-size: 12px;
    }
  }
}
#treehistorys::-webkit-scrollbar {
  display: none;
}
#treehistorys {
  display: flex;
  .history_meter {
    max-width: 890px;
    border: 1px solid #ccc;
    .history_meter_box {
      max-width: 890px;
      height: 100%;
      .history_lists {
        width: 200px;
        height: 70vh;
        overflow: hidden;
        .el-tree {
          width: 217px;
          height: 91%;
          overflow-y: scroll;
        }
      }
    }
  }

  .asdzczc {
    width: 10px;
    // height: 70vh;
    cursor: e-resize;
  }
  .asdzczcs {
    width: 10px;
    // height: 70vh;
  }
  .sapnbox2 {
    width: 30px;
    height: 100%;
    text-align: center;
    background-color: #f1f1f1;
    cursor: pointer;
    color: #346ac9;
    font-size: 16px;
  }
  .sapnbox2:hover {
    background-color: #f9f9f9;
  }
  .sapnbox {
    // width: 100%;
    min-width: 200px;
    max-width: 890px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    text-indent: 6px;
    background-color: #f1f1f1;
    position: relative;
    span {
      display: inline-block;
      width: 30px;
      height: 30px;
      cursor: pointer;
      text-align: center;
      line-height: 30px;
      text-indent: 0;
      border-radius: 5px;
    }
    span:nth-child(1) {
      position: absolute;
      top: 12%;
      right: 45%;
    }
    span:nth-child(2) {
      position: absolute;
      top: 12%;
      right: 26%;
    }
    span:nth-child(3) {
      position: absolute;
      top: 12%;
      right: 5%;
    }

    span:hover {
      background-color: #fff;
    }
  }

  .el-tree-node__expand-icon {
    font-size: 20px;
  }
  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg) !important;
    transform: rotate(0deg) !important;
  }
  .el-tree-node__expand-icon.expanded::before {
    content: "\e62e";
    font-size: 22px;
  }

  .el-table__empty-text {
    margin-left: -53% !important;
  }
}
#treehistorys .el-tree-node__expand-icon.expanded::before {
  content: "\e62e" !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/selectable/selectable.vue